export default __webpack_public_path__ + "static/media/Me.a4211605.jpeg";